export interface ISendEmailResponse {
    to: string;
    success: boolean;
    error?: string;
}
